import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "ps_cookie_consent";

/** Non-essential = PostHog product analytics + session replay. Essential = auth session, theme, offline queue. */
function applyChoice(choice) {
  if (typeof window === "undefined" || !window.posthog) return;
  try {
    if (choice === "rejected") {
      window.posthog.opt_out_capturing();
      window.posthog.stopSessionRecording?.();
    } else {
      window.posthog.opt_in_capturing();
    }
  } catch (e) {
    /* analytics must never break the app */
  }
}

export const storedConsent = () => localStorage.getItem(KEY);

export default function CookieConsent() {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));

  useEffect(() => {
    if (choice) applyChoice(choice);
    else applyChoice("rejected"); // opt out until the visitor actually accepts
  }, [choice]);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setChoice(value);
  };

  if (choice) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 border-t-2 border-[#F97316] bg-[#0A1628] text-white"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8 py-4 flex flex-col md:flex-row md:items-center gap-4">
        <Cookie className="w-5 h-5 text-[#F97316] shrink-0 hidden md:block" />
        <p className="text-[12.5px] text-white/75 leading-relaxed flex-1">
          Plan-Sarthi uses essential cookies to keep you signed in and to remember your workspace preferences, plus
          optional analytics cookies that help us improve the platform. You can reject the optional ones and still use
          everything.{" "}
          <Link to="/cookie-policy" className="text-[#F97316] hover:underline" data-testid="cookie-policy-link">
            Read our Cookie Policy
          </Link>
        </p>
        <div className="flex items-center gap-2.5 shrink-0">
          <Button
            variant="outline"
            size="sm"
            onClick={() => decide("rejected")}
            className="border-white/25 bg-transparent text-white hover:bg-white/10 hover:text-white"
            data-testid="cookie-reject-btn"
          >
            Reject optional
          </Button>
          <Button size="sm" onClick={() => decide("accepted")} data-testid="cookie-accept-btn">
            Accept all
          </Button>
        </div>
      </div>
    </div>
  );
}
